import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { DataSourceService } from '@app/finxone-web-frontend/app/lib/services/data-source-service/data-source.service';
import { registerHandlerbarHelpers } from '@app/finxone-web-frontend/app/lib/utils/template/handlebar-helpers/handlerbar-helper-register.utils';
import { IconCacheService } from '@finxone-platform/shared/services';
import { Store } from '@ngxs/store';
import { registerCustomIcons } from '../../../../libs/shared/utils/src/icons/register-icons.utils';
import { TabDetectionService } from './libs/services/tab-detection/tab-detection.service';
import { registerWorkflowCustomIcons } from '../../../../libs/shared/utils/src/workflow-icons/workflow-register-icons.utils';

@Component({
  standalone: false,
  selector: 'finxone-workflow-frontend-app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'finxone-workflow-frontend';

  constructor(
    sanitizer: DomSanitizer,
    matIconRegistry: MatIconRegistry,
    datePipe: DatePipe,
    currencyPipe: CurrencyPipe,
    countriesCurrenciesService: CountriesCurrenciesService,
    iconCacheService: IconCacheService,
    tabDetectionService: TabDetectionService,
    store: Store,
    dataSourceService: DataSourceService,
    router: Router,
    configService: ConfigService,
  ) {
    registerCustomIcons(matIconRegistry, sanitizer, iconCacheService);
    registerWorkflowCustomIcons(matIconRegistry, sanitizer);
    registerHandlerbarHelpers(
      datePipe,
      currencyPipe,
      countriesCurrenciesService,
      iconCacheService,
      store,
      dataSourceService,
      router,
      configService,
    );
  }
}
